import { HttpClient, HttpParams } from '@angular/common/http';
import { forwardRef, Injectable, NgZone } from '@angular/core';
import { UrlSerializer } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../configuration/configuration.service';
import { CmsPreviewModeService } from '../content/cms-preview-mode.service';
import { LoggerService } from '../logging/logger.service';
import { ServerVarsService } from '../server-vars/server-vars.service';
import { DeliveryCountryCookieService } from '../service/delivery-country-cookie.service';
import { PlatformService } from '../universal/platform.service';
import { ServerService } from '../universal/server.service';
import { apiServiceFactory } from './api-service.factory';
import { BasicAuthService } from './basic-auth.service';

@Injectable({
    providedIn: 'root',
    useFactory: apiServiceFactory,
    deps: [
        HttpClient,
        forwardRef(() => ConfigurationService),
        UrlSerializer,
        forwardRef(() => LoggerService),
        forwardRef(() => BasicAuthService),
        forwardRef(() => ServerVarsService),
        forwardRef(() => PlatformService),
        NgZone,
        forwardRef(() => DeliveryCountryCookieService),
        forwardRef(() => ServerService),
        forwardRef(() => CmsPreviewModeService)
    ]
})
export abstract class ApiService {
    public abstract get<T>(
        requestPath: string,
        params?: { [id: string]: any } | HttpParams,
        options?: Record<string, unknown>
    ): Observable<T>;

    public abstract post<T>(
        requestPath: string,
        params?: { [id: string]: any } | HttpParams,
        body?: { [id: string]: any },
        options?: Record<string, unknown>
    ): Observable<T>;

    public abstract put<T>(
        requestPath: string,
        params?: { [id: string]: any } | HttpParams,
        body?: { [id: string]: any },
        options?: Record<string, unknown>
    ): Observable<T>;

    public abstract delete<T>(
        requestPath: string,
        params?: { [id: string]: any } | HttpParams,
        body?: { [id: string]: any },
        options?: Record<string, unknown>
    ): Observable<T>;

    public abstract download(requestPath: string, params?: { [id: string]: any } | HttpParams): Observable<Blob>;
}
